<form [formGroup]="shiftForm">
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-4">
        <div class="card mb-4">
          <div class="card-body p-3">
            <div class="row g-3">
              <div class="col-12">
                <h5 i18n>Partner</h5>
                <div class="row">
                  <div class="col-auto">
                    <img [src]="employee.picture" style="border-radius: 50%; width: 6rem;" class="">
                  </div>
                  <div class="col">
                    <h4>{{ employee.first_name }}</h4>
                    <div>{{ employee | translateField: 'description' }}</div>
                    <span *ngIf="!employee.rating" i18n>Just started, no ratings yet</span>
                    <span *ngIf="employee.rating">
                      <span *ngIf="employee.rating >= 0.5">
                        <fa-icon [icon]="fa.faStar" style="color: #ffd700;"></fa-icon>
                      </span>
                      <span *ngIf="employee.rating >= 1.5">
                        <fa-icon [icon]="fa.faStar" style="color: #ffd700;"></fa-icon>
                      </span>
                      <span *ngIf="employee.rating >= 2.5">
                        <fa-icon [icon]="fa.faStar" style="color: #ffd700;"></fa-icon>
                      </span>
                      <span *ngIf="employee.rating >= 3.5">
                        <fa-icon [icon]="fa.faStar" style="color: #ffd700;"></fa-icon>
                      </span>
                      <span *ngIf="employee.rating >= 4.5">
                        <fa-icon [icon]="fa.faStar" style="color: #ffd700;"></fa-icon>
                      </span>
                      &nbsp;{{ employee.rating }}&nbsp;

                      <span *ngIf="employee.ratings > 0" (click)="feedback(employee)" type="button"
                        class="badge rounded-pill bg-primary cursor-pointer">
                        {{ employee.ratings }}&nbsp;<ng-container i18n>ratings</ng-container>
                      </span>
                    </span>
                    <div class="mt-2">
                      <span *ngFor="let skill of employee.skills" class="badge rounded-pill bg-secondary me-1">
                        <ng-container *ngIf="skill.language_code">{{ languageFlag(skill.language_code) }}</ng-container>
                        {{ skill | translateField: 'name' }}
                      </span>
                      <span *ngFor="let badge of employee.badges" class="badge rounded-pill bg-secondary me-1">
                        {{ badge.icon }} {{ badge | translateField: 'name' }}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="col-12 mt-3">
                  <h5 i18n>Your order</h5>
                  <p *ngIf="orderProducts.length == 0" i18n>Your order is empty. Select services by clicking on the
                    "Order" button.</p>
                  <div *ngIf="orderProducts.length > 0" class="row mb-0">
                    <div *ngFor="let product of orderProducts; let i = index"
                      class="col-12 mb-3 d-flex align-items-center">
                      <img [src]="product.product.picture" class="me-2"
                        style="width: 4rem; height: 4rem; border-radius: 50%; object-fit: cover;">
                      <div class="flex-grow-1">
                        <h6>{{ product.number | number: '1.0-2' }} x {{ product.product | translateField: 'name' }}
                          (<span style="text-transform: lowercase;">{{ product.product.unit | i18nSelect: productUnits
                            }}</span>)</h6>
                        <div *ngIf="product.notes" class="text-muted">{{ product.notes }}</div>
                      </div>
                      <div class="ms-2 text-nowrap">
                        <button (click)="editProduct(i)" class="btn btn-sm btn-primary me-1">
                          <fa-icon [icon]="fa.faEdit" style="color: #fff;"></fa-icon>
                        </button>
                        <button (click)="deleteProduct(i)" class="btn btn-sm btn-danger">
                          <fa-icon [icon]="fa.faTrash" style="color: #fff;"></fa-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                  <h5 i18n>Location</h5>
                  <button (click)="setLocation()" type="button" class="btn btn-primary w-100">
                    {{ locationName }}
                  </button>
                </div>
                <div class="col-12 mt-3">
                  <h5 i18n>Date</h5>
                  <div class="input-group rounded">
                    <input class="form-control" ngbDatepicker [markDisabled]="validStartDate" [minDate]="minDate"
                      #start_date="ngbDatepicker" formControlName="start_date" (dateSelect)="setDate($event)"
                      [readonly]="true" (click)="start_date.toggle()">
                    <button class="btn btn-primary bi bi-calendar3" (click)="start_date.toggle()" type="button"><fa-icon
                        [icon]="fa.faCalendar" style="color: #fff; position: relative; top: -2px;"></fa-icon></button>
                  </div>
                </div>
                <div class="col-12 mt-3">
                  <h5 i18n>Available</h5>
                  <div class="row">
                    <div class="col">
                      <div class="input-group">
                        <div class="input-group-text" i18n>Time</div>
                        <select class="form-control" formControlName="start_time">
                          <option *ngIf="!shiftForm.controls.customer.value" [value]="null" i18n>Set your location first
                          </option>
                          <option
                            *ngIf="shiftForm.controls.customer.value && shiftForm.controls.products.value.length == 0"
                            [value]="null" i18n>Select products and
                            services first</option>
                          <option *ngIf="shiftForm.controls.customer.value && employee.availability.length == 0"
                            [value]="null" i18n>Not available this day</option>
                          <option *ngIf="shiftForm.controls.customer.value && employee.availability.length > 0"
                            [value]="null" i18n>Select time</option>
                          <ng-container *ngIf="shiftForm.controls.customer.value">
                            <option *ngFor="let available of employee.availability" [value]="available[0]">{{
                              available[0] }} - {{ available[1] }}</option>
                          </ng-container>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 mt-3">
                  <h5 i18n>Your order</h5>
                  <p *ngIf="orderProducts.length == 0" i18n>Your order is empty. Select services by clicking the
                    "Order".
                  </p>
                  <div *ngIf="orderProducts.length > 0" class="row mb-0">
                    <div *ngFor="let product of orderProducts; let i = index"
                      class="col-12 mb-3 d-flex align-items-center">
                      <img [alt]="product.product | translateField: 'name'" [src]="product.product.picture" class="me-2"
                        style="width: 4rem; height: 4rem; border-radius: 50%; object-fit: cover;">
                      <div class="flex-grow-1">
                        <div>{{ product.number | number: '1.0-2' }} x <strong>{{ product.product | translateField:
                            'name'
                            }}</strong> (<span style="text-transform: lowercase;">{{ product.product.unit | i18nSelect:
                            productUnits
                            }}</span>)</div>
                        <div *ngIf="product.notes">{{ product.notes }}</div>
                      </div>
                      <div class="ms-2 text-nowrap">
                        <button (click)="editProduct(i)" class="btn btn-primary me-1">
                          <fa-icon [icon]="fa.faEdit" style="color: #fff; position: relative; top: -1px;"></fa-icon>
                        </button>
                        <button (click)="deleteProduct(i)" class="btn btn-danger">
                          <fa-icon [icon]="fa.faTrash" style="color: #fff; position: relative; top: -1px;"></fa-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div>
                    <span i18n>Total:</span>&nbsp;
                    <ng-container *ngIf="!loading">{{ employee.price | currency: organization.currency }}</ng-container>
                    <ng-container *ngIf="loading">
                      <div style="position: relative; top: -2px;" class="spinner-border spinner-border-sm"
                        role="status">
                      </div>
                    </ng-container>
                  </div>
                </div>
                <div class="col-12 mt-3">
                  <button [disabled]="shiftForm.invalid" class="btn btn-primary w-100"
                    (click)="selectEmployee(employee.id, $event)" i18n>Continue</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-8">
        <div *ngIf="assignments && assignments.length > 0" class="card mb-4">
          <div class="card-cody p-3">
            <h5 i18n>Available products and services</h5>
            <select (change)="selectAssignment()" class="form-select" id="assignment_id"
              formControlName="assignment_id">
              <option *ngFor="let assignment of assignments | localeSort: 'name'" [ngValue]="assignment.id">{{
                assignment
                | translateField: 'name' }}</option>
            </select>
            <p *ngIf="selectedAssignment && selectedAssignment.description" class="mt-3 mb-0" i18n>{{ selectedAssignment
              |
              translateField: 'description' }}</p>
            <p *ngIf="selectedAssignment && selectedAssignment.description_local" class="mt-3 mb-0" i18n>{{
              selectedAssignment | translateField: 'description_local' }}</p>
          </div>
        </div>
        <div *ngIf="assignments && assignments.length < 1" class="card mb-4">
          <div class="card-cody p-3 text-center">
            <p class="text-center" i18n>This partner is not offering any products or services at the moment.</p>
            <a routerLink="/" class="btn btn-primary" i18n>Find antoher partner</a>
          </div>
        </div>
        <div class="row row-cols-1 row-cols-md-2 align-items-stretch">
          <ng-container *ngFor="let product of products | localeSort: 'name'">
            <div class="col d-flex mb-4">
              <div class="card m-0 d-flex w-100 flex-column flex-grow-1"
                [style.background-image]="'url(' + product.picture + ')'"
                style="background-size: cover; background-position: center; min-height: 17rem; overflow: hidden;">
                <div class="card-header" style="height: 12rem; border: none;"></div>
                <div class="card-body p-3 d-flex flex-column flex-grow-1" style="background: rgba(255,255,255,0.85);">

                  <h4>{{ product | translateField: 'name' }} (<span style="text-transform: lowercase;">{{
                      product.unit | i18nSelect: productUnits }}</span>)</h4>
                  <p>{{ product | translateField: 'description' }}</p>
                  <p *ngIf="product.description_local">{{ product | translateField: 'description_local' }}</p>
                  <button (click)="orderProduct(product, null)" type="button" class="btn btn-primary">
                    <span i18n="Order button for ordering a product">Order</span>
                  </button>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <ng-container *ngIf="platform == 'web'">
    <div class="col row p-3" style="background-color: #111;">
      <div class="col-6 col-md-3">
        <a routerLink="/"><img src="assets/images/logo-text.webp"
            style="width: 9.5rem; position: relative; left: 0.4rem;" class="mb-3"></a>
        <a href=""><img src="assets/images/app-store.png" style="height: 3rem; display: block;" class="mb-3"></a>
        <a href=""><img src="assets/images/play-store.png" style="height: 3rem; display: block;" class="mb-3"></a>
      </div>
      <div class="col-6 col-md-3 mb-3">
        <h5 i18n>Partner with Nuuduu</h5>
        <a [href]="'/partners/' + locale + '/find-work'" class="d-block" i18n>Find work</a>
        <a [href]="'/partners/' + locale + '/about'" class="d-block" i18n>What is Nuuduu for partners</a>
        <a [href]="'/partners/' + locale + '/signin'" class="d-block" i18n>Start working</a>
      </div>
      <div class="col-6 col-md-3 mb-3">
        <h5 i18n>Useful links</h5>
        <a routerLink="/" class="d-block" i18n>Discover services</a>
        <a routerLink="/about" class="d-block" i18n>What is Nuuduu for customers</a>
        <a routerLink="/signin" class="d-block" i18n>Sign in / Sign up</a>
        <a routerLink="/press" class="d-block" i18n>Press &amp; Media</a>
      </div>
      <div class="col-6 col-md-3">
        <h5 i18n>Follow us</h5>
        <a [href]="(organization | translateField: 'customer_facebook_link') || defaultFacebookLink" target="_blank"
          class="d-block">Facebook</a>
        <a [href]="(organization | translateField: 'customer_x_link') || defaultXLink" target="_blank"
          class="d-block">X</a>
        <a [href]="(organization | translateField: 'customer_youtube_link') || defaultYoutubeChannelLink"
          target="_blank" class="d-block">YouTube</a>
      </div>
    </div>
    <div class="row p-3 align-items-center" style="background-color: #111;">
      <div class="col-4 text-nowrap">
        <a (click)="languageSelector()" class="nav-link cursor-pointer" data-bs-dismiss="offcanvas">
          <ng-container *ngIf="organization && organization.country_code">
            <img [src]="'assets/images/flags/' + organization.country_code.toLocaleLowerCase() + '.webp'"
              style="height: 1rem; border: none; position: relative; top: -1px;" class="me-1">
            {{ locale | i18nSelect: locales }}
          </ng-container>
          <ng-container *ngIf="!organization">
            <fa-icon [icon]="fa.faGlobe" style="color:#fff;"></fa-icon>&nbsp;
            <ng-container i18n>Location</ng-container>
          </ng-container>
        </a>
      </div>
      <div class="col-8 text-end">
        <a href="javascript:void(0)" (click)="privacyPolicy()" class="text-nowrap" i18n>Privacy policy</a>&nbsp;&nbsp;
        <a href="javascript:void(0)" (click)="tnc()" class="text-nowrap" i18n>Terms &amp; conditions</a>&nbsp;&nbsp;
        <span class="text-nowrap">&copy; Nuuduu UAB {{ copyrightYear }}</span>
      </div>
    </div>
  </ng-container>
</form>